// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__b6gSI","contentWrapper":"styles_contentWrapper___ay9V","pricingOffersWrapper":"styles_pricingOffersWrapper__Wv5jn"};